import { render, staticRenderFns } from "./HomeworkStatis.vue?vue&type=template&id=0ff6996e&scoped=true&"
import script from "./HomeworkStatis.vue?vue&type=script&lang=js&"
export * from "./HomeworkStatis.vue?vue&type=script&lang=js&"
import style0 from "./HomeworkStatis.vue?vue&type=style&index=0&id=0ff6996e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff6996e",
  null
  
)

export default component.exports